import { createRequestTypes } from '../utils';

export const SUBSTANCE_TR_LIST = createRequestTypes('substanceTR/SUBSTANCE_TR_LIST');
export const SAVE_SUBSTANCE_TRs = createRequestTypes('substanceTR/SAVE_SUBSTANCE_TRs');

